//used by inst and learner
const state = {
    course_data:null, //learner
    current_video_index:0, //learner
    video_data: null,  //course content to video
    video_links: null, //video to video player
    material_data: null,  //course content to material
    assignment_data: null,  //course content to material
    useful_links_data: null,  //course content to material
    inst_course_data: null,  //Ins
}

const getters = {
    video_data: state => state.video_data,
    current_video_index: state => state.current_video_index,
    course_data: state => state.course_data,
    video_links: state => state.video_links,
    material_data: state => state.material_data,
    assignment_data: state => state.assignment_data,
    useful_links_data: state => state.useful_links_data,
    inst_course_data: state => state.inst_course_data,
}

const actions = {
    
}

const mutations = {
    // SET_SNACKBAR(state, snackbar) {
    //     state.snackbars = state.snackbars.concat(snackbar);
    // },
    set_course_data(state, course_data) {
        state.course_data = course_data
    },
    set_current_video_index(state, current_video_index) {
        state.current_video_index = current_video_index
    },
    set_video_data(state, video_data) {
        state.video_data = video_data
    },
    set_video_links(state, video_links) {
        state.video_links = video_links
    },
    set_material_data(state, material_data) {
        state.material_data = material_data
    },
    set_assignment_data(state, assignment_data) {
        state.assignment_data = assignment_data
    },
    set_useful_links_data(state, useful_links_data) {
        state.useful_links_data = useful_links_data
    },
    set_inst_course_data(state, inst_course_data) {
        state.inst_course_data = inst_course_data
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}